(function () {
  var codes = [121, 117, 115, 98, 111, 120, 64, 121, 117, 115, 98, 111, 120, 46, 99, 111, 109];
  var email = codes.map(function (code) {
    return String.fromCharCode(code);
  }).join('');

  document.querySelectorAll('[data-yusbox-email-link]').forEach(function (link) {
    link.textContent = email;
    link.href = 'mailto:' + email;
    link.classList.add('is-decoded');
    link.removeAttribute('data-yusbox-email-link');
  });
})();
